import { CommonList, CommonListParams } from "@/types/common";
import request from ".";
import { DictLikeNumberKey } from "@/types/dict";
import { AddLogistics, AddLogistcsEvent, AddShipItem, AddShipment, Logistics, LogisticsEvent, Shipment } from "@/types/shipment";
import { PackOrder } from "@/types/packing";
import { OrderV2 } from "@/types/inventoryV2";

const URL = '/wms/v2/shipment';


const APIS = {
  statusTypes: `${URL}/status/types`,
  shipMethods: `${URL}/shipMethod/types`,
  shipLogistcs: `${URL}/logisticsStatus/types`,
  shipEvents: `${URL}/eventStatus/types`,
  orderList: URL + '/order/list',
  orderAdd: URL + '/order/add',
  orderFetch: (id: string) => `${URL}/order/${id}/fetch`,
  orderUpdate: (id: string) => `${URL}/order/${id}/update`,
  orderStatusUpdate: (id: string) => `${URL}/order/${id}/status/update`,
  orderCancel: (id: string) => `${URL}/order/${id}/cancel`,
  shipmentPack: (id: string, type: "get" | "fetch") => `${URL}/${id}/pack/${type}`,
  logisticsAdd: URL + '/logistics/add',
  logisticsUpdate: (id: string) => `${URL}/logistics/${id}/update`,
  logisticsFetch: (id: string) => `${URL}/logistics/${id}/fetch`,
  logisticsEventAdd: (id: string) => `${URL}/logistics/${id}/event/add`,
  logisticsEventDel: (id: string) => `${URL}/logistics/${id}/event/del`,
  logisticsShip: (id: string) => `${URL}/logistics/${id}/ship`,
  shipmentLogistics: (id: string) => `${URL}/${id}/logistics/get`,
  shipmentInventory: (id: string) => `${URL}/${id}/inventoryOrders`,
};

export const orderStatus = () => {
  return new Promise<Array<DictLikeNumberKey>>((resolve, reject) => {
    request<Array<DictLikeNumberKey>, undefined>(APIS.statusTypes)
      .then(res => resolve(res.body))
      .catch(err => reject(err))
  })
};

export const shipMethods = () => {
  return new Promise<Array<DictLikeNumberKey>>((resolve, reject) => {
    request<Array<DictLikeNumberKey>, undefined>(APIS.shipMethods)
      .then(res => resolve(res.body))
      .catch(err => reject(err))
  })
};

export const shipLogistcs = () => {
  return new Promise<Array<DictLikeNumberKey>>((resolve, reject) => {
    request<Array<DictLikeNumberKey>, undefined>(APIS.shipLogistcs)
      .then(res => resolve(res.body))
      .catch(err => reject(err))
  })
};

export const shipEvents = () => {
  return new Promise<Array<DictLikeNumberKey>>((resolve, reject) => {
    request<Array<DictLikeNumberKey>, undefined>(APIS.shipEvents)
      .then(res => resolve(res.body))
      .catch(err => reject(err))
  })
};
export interface ShipListParam {
  keyword?: string;
}
export const orderList = (params: CommonListParams<ShipListParam>) => {
  return new Promise<CommonListParams<Array<Shipment>>>((resolve, reject) => {
    request<Array<Shipment>, ShipListParam>(APIS.orderList, { params })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  })
};

export const orderAdd = (body: AddShipment) => {
  return new Promise<Shipment>((resolve, reject) => {
    request<Shipment, AddShipment>(APIS.orderAdd, { params: { body } })
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  })
};

export const orderFetch = (id: string, controller?: AbortController) => {
  return new Promise<Shipment>((resolve, reject) => {
    request<Shipment, undefined>(APIS.orderFetch(id), { controller })
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  })
};

export const orderUpdate = (id: string, body: AddShipment) => {
  return new Promise<Shipment>((resolve, reject) => {
    request<Shipment, AddShipment>(APIS.orderUpdate(id), { params: { body } })
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  })
};

export const orderStatusUpdate = (id: string, body: number) => {
  return new Promise<void>((resolve, reject) => {
    request<void, number>(APIS.orderStatusUpdate(id), { params: { body } })
      .then(() => resolve())
      .catch((err) => reject(err));
  })
};

export const orderCancel = (id: string) => {
  return new Promise<void>((resolve, reject) => {
    request<void, undefined>(APIS.orderCancel(id))
      .then(() => resolve())
      .catch((err) => reject(err));
  })
};

export const shipmentPack = (id: string, type: "get" | "fetch") => {
  return new Promise<PackOrder | null>((resolve, reject) => {
    request<PackOrder | null, undefined>(APIS.shipmentPack(id, type))
      .then(({ body }) => resolve(body))
      .catch(err => reject(err))
  })
};

export const logisticsAdd = (body: AddLogistics) => {
  return new Promise<Logistics>((resolve, reject) => {
    request<Logistics, AddLogistics>(APIS.logisticsAdd, { params: { body } })
      .then(({ body }) => resolve(body))
      .catch(err => reject(err))
  })
};

export const logisticsUpdate = (id: string, body: AddLogistics) => {
  let { packingOrderId, shipmentOrderId, ...restBody } = body;
  return new Promise<Logistics>((resolve, reject) => {
    request<Logistics, Omit<AddLogistics, "packingOrderId" | "shipmentOrderId">>(APIS.logisticsUpdate(id), { params: { body: restBody } })
      .then(({ body }) => resolve(body))
      .catch(err => reject(err))
  })
};

export const logisticsFetch = (id: string) => {
  return new Promise<Logistics>((resolve, reject) => {
    request<Logistics, undefined>(APIS.logisticsFetch(id))
      .then(({ body }) => resolve(body))
      .catch(err => reject(err))
  })
};

export const logisticsEventAdd = (id: string, body: AddLogistcsEvent) => {
  return new Promise<LogisticsEvent>((resolve, reject) => {
    request<LogisticsEvent, AddLogistcsEvent>(APIS.logisticsEventAdd(id), { params: { body } })
      .then(({ body }) => resolve(body))
      .catch(err => reject(err))
  })
};

export const logisticsEventDel = (id: string) => {
  return new Promise<void>((resolve, reject) => {
    request<void, undefined>(APIS.logisticsEventDel(id))
      .then(() => resolve())
      .catch(err => reject(err))
  })
};

export const logisticsShip = (id: string) => {
  return new Promise<void>((resolve, reject) => {
    request<void, undefined>(APIS.logisticsShip(id))
      .then(() => resolve())
      .catch(err => reject(err))
  })
};

export const shipmentLogistics = (id: string) => {
  return new Promise<Logistics | null>((resolve, reject) => {
    request<Logistics | null, undefined>(APIS.shipmentLogistics(id))
      .then(({ body }) => resolve(body))
      .catch(err => reject(err))
  })
};

export const shipmentInventory = (id: string) => {
  return new Promise<OrderV2[]>((resolve, reject) => {
    request<OrderV2[], undefined>(APIS.shipmentInventory(id))
      .then(({ body }) => resolve(body))
      .catch(err => reject(err))
  })
};
